import React from 'react';
import { ExcelTableCellProps } from '../../TableCell';
import { WeaDatePicker } from 'ecCom';
import { observer } from 'mobx-react';
import { getDomIdByFieldKey } from '../../../../util/typeUtil';
import _ from 'lodash';

@observer
export default class DatePicker extends React.Component<ExcelTableCellProps, any> {
    constructor(props) {
        super(props);
        const { cell, form } = this.props;
        const path = cell.getPath();
        const bindObj = form.$(path);
        const bind = bindObj.bind();
        let value = "" || _.trim(bind.value);
        this.state = {
          value: value
        };
      }
    render() {
        const { cell, form, card, className, excel } = this.props;
        const { value } = this.state;
        const path = cell.getPath();
        const bindObj = form.$(path);
        const { fieldtype } = card.getFieldProps(path);
        const fieldName = getDomIdByFieldKey(bindObj.path);
        const bind = bindObj.bind();
        const {quickEditStore ,getDetailFormValues} = card;
        const { viewAttr: _viewAttr, isEdit, isMandatory } = bind;
        let viewAttr = _viewAttr ? _viewAttr : (isMandatory ? 3 : (isEdit ? 2 : 1));
        if(excel.detailProps&&excel.detailProps.hasOwnProperty("isEdit")&&card.params.type == '2'){
            //如果明细表字段，设置了不可编辑已有明细
            if(getDetailFormValues(form).dtl_id&&!excel.detailProps["isEdit"]){
                viewAttr = 1;
            }
        }
        let format="YYYY";
        if(fieldtype == '403'){
            format = "YYYY-MM";
        }
        
        let canQuickedit = bindObj.isquickedit && viewAttr == '1';
        //新增 显示模板的快编模式下 编辑模板中是否允许修改已有明细的判断
        if (canQuickedit && excel.detailProps && !excel.detailProps["isEdit"]) {
            canQuickedit = false;
        }
		let isDisplay = '';
        if(!canQuickedit){
            isDisplay = 'none';
        }
        return (
            <div className={`${canQuickedit ? 'cube-card-editformitem ':'cube-card-editformitem2'} fieldValue ${className}`} data-fieldattr={viewAttr} data-fieldmark={fieldName} {...cell.cellProps}
            onClick={() => { canQuickedit && quickEditStore.lockEditFormItem(fieldName); }}
            >
                <WeaDatePicker ecId={`${this && this.props && this.props.ecId || ''}_WeaDatePicker@b0r3qz`}
                    {...bind}
                    value={value}
                    fieldName={fieldName}
                    noInput={true}
                    viewAttr={viewAttr}
                    format={format}
                    onChange={(value) => {this.setState({ value });bind.onChange(value);}}
                />
                <span className="editicon" style={{display:isDisplay}}><i className="icon-coms-edit" ></i></span>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/cell-field/browser-element/YearMonthPicker.tsx